"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    rootMargin: "50px"
  });
  return <section id="hero" className="dark bg-background text-foreground relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="container mx-auto px-4 py-16 lg:py-24">
        <div className="grid gap-12 items-center !w-[1500px] lg:grid-cols-2 lg:gap-16">
          {}
          <div ref={leftRef} className={`space-y-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <h1 className="font-display font-bold text-[clamp(2.5rem,5vw,3.5rem)] leading-[1.2] tracking-tight text-primary-dark !w-[1500px]">Energy Infrastructure for<br />&nbsp;Digital Asset Operations</h1>
            <p className="text-lg leading-[1.6] text-foreground max-w-3xl text-left">West Indian Digital repurposes stranded and vented methane from oil and gas production to power Bitcoin mining infrastructure across the Caribbean, reducing carbon impact through systematic energy utilisation and institutional governance.</p>
            <div className="pt-4">
              <Button className="btn-primary" asChild>
                <Link to="#infrastructure">View Infrastructure</Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`relative h-[400px] lg:h-[500px] rounded-[var(--radius-sm)] overflow-hidden shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
          transitionDelay: "100ms"
        }}>
            <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1545031/img/industrial_mining_infrastructure_wide_angle.png)] animate-ken-burns" />
            <div className="absolute inset-0 media-overlay" />
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes ken-burns {
          0% {
            transform: scale(1);
          }
          100% {
            transform: scale(1.08);
          }
        }

        .animate-ken-burns {
          animation: ken-burns 20s ease-out infinite alternate;
        }

        @media (prefers-reduced-motion: reduce) {
          .animate-ken-burns {
            animation: none;
            transform: none;
          }
        }
      `}</style>
    </section>;
}